<template lang="html">
    <div class="dashboard-card md-layout-item md-size-50" v-loader-overlay="loading">
        <md-card>
            <md-card-header>
                <div class="md-title" v-html="this.name"></div>
            </md-card-header>
            <md-card-content>
                <md-list class="can-scroll" v-if="!loading && debtors.length">
                    <md-list-item v-for="debtor in debtors" v-bind:key="`dashboard-debtor-${debtor.id}`">
                        <router-link
                            class="md-list-item-text"
                            v-bind:to="{ name: 'Customer', params: { customer_id: debtor.id} }"
                        >{{debtor.name}}</router-link>
                        <span class="md-list-action">{{ `${ price.format(debtor.debt_sum) } руб.` }}</span>
                    </md-list-item>
                </md-list>
                <div v-if="!loading && !debtors.length">Должников не найдено</div>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
  import price from '@/helpers/price/index.js';
  export default {
    module: 'finance',
    data() {
      return {
        name: 'Должники',
        uniqueCode: 'debtors',
        loading: false,
        module: 'finance',
        price: price
      }
    },
    computed: {
      debtors() {
        return this.$store.state.finance.debtors
      }
    },
    methods: {
      getDebtors() {
        this.loading = true;
        this.$store.dispatch('finance/getDebtors').finally(() => this.loading = false);
      }
    },
    created() {
      this.getDebtors();
    }
  }
</script>
<style lang="sass">
  .dashboard-card
    .md-card-content
    .md-list
      background-color: #fff
      max-height: 500px
      overflow-y: auto
</style>



// WEBPACK FOOTER //
// DebtorsDashboard.vue?b594c860